import ModuleEInvoiceDetail from "./ModuleEInvoiceDetail.vue";

export default ModuleEInvoiceDetail